const render = ({placementid, pubid}) => {
  return `
<script type="text/javascript" src="https://ldsapi.tmginteractive.com/generateplacementscript.aspx?placement=${placementid}&publisher=${pubid}&affid=&subid={pe_key}&firstname={firstName_urlencoded}&lastname={lastName_urlencoded}&email={email_urlencoded}&zip={zip_urlencoded}&address={address1_urlencoded}&gender={gender_urlencoded}&dob={dob_slashes_mmddyyyy_urlencoded}&address2={address2_urlencoded}&city={city_urlencoded}&state={state_urlencoded}&phone={phone_urlencoded}&country=US&redirect={nextURL_urlencoded}"></script>
  `.trim()
};

export default render;